//OAuthCallback.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const OAuthCallback = () => { 
  const { acceptToken } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    /* 1️⃣  grab token & next from the hash  */
    const hash   = window.location.hash.substring(1);          // strip '#'
    const params = new URLSearchParams(hash);
    const token  = params.get('token');
    const next   = params.get('next') || '/';
    if (!token) {
      // legacy flow (cookie).  Fallback to old /auth/check if desired:
      return navigate('/');
    }

    /* 2️⃣  store token → interceptor will add it from now on  */
    acceptToken(token);
    
         
    window.postMessage({               // NEW
      action: 'hvForwardToken',
      token
    });
    /* 3️⃣  (optional) hit /api/me to fetch full profile  */
    // axios.get('/api/me').then(r => setUser(r.data));
    console.log('OAuthCallback: token accepted:', token);
    navigate(next);
  }, [acceptToken, navigate]);
  /*
  useEffect(() => {
    fetch('/api/auth/check', {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.user) {
          setUser(data.user);
          localStorage.setItem('user', JSON.stringify(data.user));
          navigate('/');
        } else {
          navigate('/login');
        }
      })
      .catch((err) => {
        console.error('OAuth check error:', err);
        navigate('/login');
      });
  }, [setUser, navigate]);
*/
  return <p>Logging you in...</p>;
};

export default OAuthCallback;
